import * as React from 'react';
import { Button, Col } from 'react-bootstrap';
import { WithTranslation, withTranslation } from 'react-i18next';
import CommonModal from '../common/CommonModal';
import Select, { SingleValue } from 'react-select';
import { measurementPointResultStatusTypesEnum } from '../../models-enums';
import { bulkUpdateInstallBaseStatuses } from '../../actions/manageInventoryActions';
import { useState } from 'react';

interface Iprops {
    show: boolean;
    onHide: () => void;
    colorButton: string;
    className?: string;
    secondModal?: boolean;
    installBaseIds: string[];
    onSuccess: () => void;
}

const BulkStatusChangeModal: React.FC<Iprops & WithTranslation> = props => {
    const {
        t,
        show,
        onHide,
        colorButton,
        className,
        secondModal,
        installBaseIds,
        onSuccess
    } = props;

    const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

    const filterStatusOptions = Object.keys(
        measurementPointResultStatusTypesEnum
    )
        .filter(option => isNaN(Number(option))) // Filter out index elements
        .map(option => ({
            label: t(`manageInventory:${option}`),
            value: String(
                measurementPointResultStatusTypesEnum[
                    option as keyof typeof measurementPointResultStatusTypesEnum
                ]
            ),
            data: undefined
        }));

    const onSave = async () => {
        if (!selectedStatus) {
            return;
        }

        await bulkUpdateInstallBaseStatuses(installBaseIds, selectedStatus);

        onSuccess();
    };

    const handleStatusChange = (
        selectedOption: SingleValue<{
            label: string;
            value: string;
            data: undefined;
        }>
    ) => {
        if (!selectedOption) {
            console.log('no selected option');
            return;
        }

        setSelectedStatus(selectedOption.value);
    };

    return (
        <CommonModal
            show={show}
            className={className ?? ''}
            onHide={onHide}
            title={t('manageInventory:changeInstallBaseStatus')}
            container={document.getElementById('two-pane-layout')}
            secondModal={secondModal}
        >
            <div className="status-change-modal">
                <div className="form-group">
                    <label htmlFor="status-label" className="control-label">
                        {t('common:status')}
                    </label>
                    <Select
                        inputId="status-select"
                        options={filterStatusOptions}
                        isMulti={false}
                        isOptionSelected={option =>
                            option.value === selectedStatus
                        }
                        onChange={handleStatusChange}
                        placeholder={t('manageInventory:statusPlaceholder')}
                    />
                </div>
            </div>

            <Col xs={12} className="form-buttons text-right">
                <Button
                    bsStyle="default"
                    type="button"
                    className="pull-left"
                    onClick={onHide}
                >
                    {t('common:cancel')}
                </Button>
                <Button bsStyle={colorButton} onClick={onSave}>
                    {t('common:save')}
                </Button>
            </Col>
        </CommonModal>
    );
};

export default withTranslation()(BulkStatusChangeModal);
